import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-agent.dto';
export * from './dtos/agents-stats.dto';
export * from './dtos/agent-list.dto';
export * from './dtos/agent-record.dto';
export * from './dtos/agent-activity-event.dto';
export * from './dtos/agent-activity-event-hydration.dto';
export * from './dtos/agent-search.dto';
export * from './dtos/update-agent.dto';

export * from './enums/agent-type.enum';
export * from './enums/agent-status.enum';
export * from './enums/agent-action.enum';

export * from './functions/agent-status-to-color.function';

export * from './types/agents-filters';

export * from './validators/schemas/create-agent.schema';
export * from './validators/schemas/update-agent.schema';

export const agentValidators = { canCreateOrUpdate, canPerformAction };
